import { get } from 'services/api';
import { isEmpty } from '@iterable/utils';

export const AGGREGATE_EVENTS_URL = '/users/profiles/aggregateEvents/';
export const EVENTS_URL = '/users/profiles/events/';
export const USER_AGENTS_URL = '/users/profiles/events/:userKey/userAgents';

type QueryData = { startTime: number; endTime: number };

const formatDateQuery = (queryData?: QueryData) => {
  if (!queryData || isEmpty(queryData)) {
    return '';
  }
  const { startTime, endTime } = queryData;
  return `?startTime=${startTime}&endTime=${endTime}`;
};

export const getAggregateUserEvents = (email: string, queryData?: QueryData) =>
  get(`${AGGREGATE_EVENTS_URL}${email}${formatDateQuery(queryData)}`);

export const getUserEvents = (options: { from: number; limit: number; filter: string }) => {
  const searchParams = new URLSearchParams();
  searchParams.set('from', options.from.toString());
  searchParams.set('limit', options.limit.toString());
  searchParams.set('filter', options.filter);
  return get(`${EVENTS_URL}?${searchParams.toString()}`);
};
